import { Container, Box, makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React, { useEffect, useState, Fragment } from "react";
import { Helmet } from "react-helmet";
import { PageBanner } from "../../components";
import { backend } from "../../api";
import { useParams } from "react-router";
import PDFViewer from "pdf-viewer-reactjs";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import CustomNavigation from "./Navigation";
import "./article.css";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  headingsContainer: {
    textAlign: "center",
    margin: "100px 0",
    color: theme.palette.secondary.light,
  },
  infoContainer: {
    textAlign: "justify",
    margin: "70px 0",
    color: theme.palette.secondary.light,
  },
  sectionHeading: {
    fontSize: "64px",
    color: theme.palette.secondary.light,
    fontWeight: 700,
    letterSpacing: 0.1,
    margin: "0 20px",
    lineHeight: "60px",
    [theme.breakpoints.down("md")]: {
      fontSize: "54px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "45px",
      lineHeight: "40px",
      marginTop: "30px",
    },
  },
}));

function ReadArticle() {
  const classes = useStyles();
  const { currentUser } = useSelector((state) => state.auth);
  const [currentArticle, setCurrentArticle] = useState();
  const { articleId } = useParams();

  useEffect(() => {
    fetchCurrentArticle();
  }, []);

  const fetchCurrentArticle = () => {
    // Fetch article order if it exists
    backend
      .get(`/articleorder?user=${currentUser._id}&article=${articleId}`)
      .then((res) => {
        if (res.data.data.length > 0) {
          setCurrentArticle(res.data.data[0].article);
        } else {
          // If no article order exists, fetch the article by ID
          fetchArticleById();
        }
      })
      .catch((err) => {
        // If there is an error fetching the article order, fetch the article by ID
        fetchArticleById();
      });
  };

  const fetchArticleById = () => {
    backend
      .get(`/article/${articleId}`)
      .then((res) => {
        setCurrentArticle(res.data.data);
      })
      .catch((err) => {
        toast.error(err.response ? err.response.data.message : err.message);
      });
  };

  return (
    <Fragment>
      <Helmet>
        <title> E-Article Reading Zone</title>
      </Helmet>
      <PageBanner title="E-Article Reading Zone" image="/assets/images/bg4.jpg" />
      <div className={classes.headingsContainer}>
        <h6 style={{ fontWeight: 400, fontSize: "14px", letterSpacing: 5 }}>
          Enjoy Your Article
        </h6>
        <h2 className={classes.sectionHeading}> Decade 2 Publishing</h2>
      </div>

      <Container>
        <Box my={5}>
          {currentArticle ? (
            <Box>
              <div className={classes.infoContainer}>
                <h6
                  style={{
                    fontWeight: 500,
                    fontSize: "13px",
                    letterSpacing: 3,
                  }}
                >
                  Article Title : {currentArticle.article_title}
                </h6>
                <h6
                  style={{
                    fontWeight: 500,
                    fontSize: "13px",
                    letterSpacing: 3,
                  }}
                >
                  Article Author : d2p
                </h6>
              </div>
              <PDFViewer
                document={{
                  url: currentArticle.pdf_file,
                }}
                navbarOnTop
                protectContent
                password="abcdefgh"
                css="customViewer"
                canvasCss="customCanvas"
                minScale={0.5}
                scaleStep={0.5}
                navigation={CustomNavigation}
              />
            </Box>
          ) : (
            <Box>
              <Skeleton animation="wave" />
            </Box>
          )}
        </Box>
      </Container>
    </Fragment>
  );
}

export default ReadArticle;
